import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import { ShareButtonsContainer as ShareButtons } from 'ha/modules/Contentful/containers/ShareButtons';
import { RelatedArticles } from 'ha/modules/Contentful/components/RelatedArticles';
import { units } from '@ha/dsl';

import { BlogCard } from './BlogCard';
import { BlogForm } from './BlogForm';
import { CTAFindRoom } from './CTAFindRoom';
import {
  HermesData,
  BlogForm as BlogFormType,
  BlogCard as BlogCardType,
} from '../types';
import { Content } from './Content';
import { isArticleUpdated } from '../utils/isArticleUpdated';

export const styles = () =>
  createStyles({
    shareButtons: {
      marginBottom: units.rem(3.75),
      width: 'auto',
    },
    cta: {
      marginBottom: units.rem(3.75),
    },
  });

interface Props {
  data: HermesData;
  isCTADisabled: boolean;
}

export const MobileLayoutInternal: React.FC<
  Props & WithStyles<typeof styles>
> = ({ data, isCTADisabled, classes }) => {
  const {
    author,
    content,
    city,
    country,
    title,
    relatedArticles,
    ctaType,
    cta,
    createdAt,
    updatedAt,
    hideReadingTime,
    topicCluster,
  } = data;

  return (
    <React.Fragment>
      <Content
        author={author}
        content={content}
        city={city}
        country={country}
        isUpdated={isArticleUpdated(createdAt, updatedAt)}
        hideReadingTime={hideReadingTime}
        data-test-locator="Blog MobileLayout Content"
        topicCluster={topicCluster}
      />

      <ShareButtons
        title={title}
        wrapperClassname={classes.shareButtons}
        isMobile
        data-test-locator="Blog MobileLayout ShareButtons"
      />

      {!isCTADisabled && (
        <div className={classes.cta} data-test-locator="Blog MobileLayout CTA">
          {ctaType === 'card' && cta && <BlogCard {...(cta as BlogCardType)} />}
          {ctaType === 'form' && cta && <BlogForm {...(cta as BlogFormType)} />}
          {!ctaType && city && country && (
            <CTAFindRoom city={city} country={country} />
          )}
        </div>
      )}

      {relatedArticles && relatedArticles.length > 0 && (
        <RelatedArticles articles={relatedArticles} />
      )}
    </React.Fragment>
  );
};

const MobileLayout = withStyles(styles)(MobileLayoutInternal);
export { MobileLayout };
